module.exports = __webpack_public_path__ + "static/media/government.9a5a8e35.png";